// Pop-up-vragen bij overlap (SPEC_wijzigingen 5.4): "deze post zit normaal al in de prijs van
// [post], toch apart betalen?". Een open post telt niet mee tot er beslist is; de beslissing
// wordt geleerd voor volgende calculaties met dezelfde prijslijst.
import type { MatchedLine } from '@recotex/shared';
import { fmtEUR, fmtNum } from '../lib/format';

export type OverlapStatus = NonNullable<MatchedLine['overlap']>['status'];

/** Zet de beslissing op één lijn. */
export function beslisOverlap(lines: MatchedLine[], lineId: string, status: OverlapStatus): MatchedLine[] {
  return lines.map((l) => (l.id === lineId && l.overlap ? { ...l, overlap: { ...l.overlap, status } } : l));
}

export function OverlapVragen({
  lines,
  editable,
  magBevestigen,
  onBeslis,
}: {
  lines: MatchedLine[];
  editable: boolean;
  /** Enkel Eranda, Timen, Ervin of Jordy kunnen de vraag beantwoorden (5.4). */
  magBevestigen: boolean;
  onBeslis: (lineId: string, status: OverlapStatus) => void;
}) {
  const metOverlap = lines.filter((l) => l.overlap);
  if (!metOverlap.length) return null;
  const open = metOverlap.filter((l) => l.overlap!.status === 'open');
  return (
    <div className={`card mb-5 border-l-4 ${open.length ? 'border-warning' : 'border-border'} normal-case tracking-normal`}>
      <h3 className="text-lg font-bold mb-1">{open.length ? `Bevestiging nodig (${open.length})` : 'Posten die normaal al inbegrepen zijn'}</h3>
      <p className="text-xs text-secondary mb-3">
        Deze posten zitten normaal al in de prijs van een andere post op deze calculatie. Ze tellen pas mee nadat je bevestigt dat ze toch
        apart betaald worden. Je keuze wordt onthouden voor volgende calculaties met deze prijslijst.
        {editable && !magBevestigen && <strong className="block mt-1">Enkel Eranda, Timen, Ervin of Jordy kunnen deze vraag beantwoorden.</strong>}
      </p>
      <div className="space-y-2">
        {metOverlap.map((l) => {
          const o = l.overlap!;
          return (
            <div key={l.id} className={`rounded-md px-3 py-2 flex items-center gap-3 flex-wrap ${o.status === 'open' ? 'bg-warning-100' : 'bg-lightgrey'}`}>
              <div className="flex-1 min-w-[240px] text-sm">
                <strong>{l.naamArbeid}</strong> ({fmtNum(l.hoeveelheid)} {l.eenheid}{l.prijs != null ? ` × ${fmtEUR(l.prijs)}` : ''}) zit normaal al in de prijs van{' '}
                <strong>{o.inbegrepenInNaam}</strong>. Toch apart betalen?
              </div>
              {o.status !== 'open' && (
                <span className={o.status === 'bevestigd' ? 'chip-success' : 'chip-neutral'}>{o.status === 'bevestigd' ? 'apart betaald' : 'niet betaald'}</span>
              )}
              {editable && magBevestigen && (
                <div className="flex gap-2">
                  <button className={o.status === 'bevestigd' ? 'btn-primary btn-sm' : 'btn-ghost btn-sm'} onClick={() => onBeslis(l.id, 'bevestigd')}>Ja, apart betalen</button>
                  <button className={o.status === 'geweigerd' ? 'btn-primary btn-sm' : 'btn-ghost btn-sm'} onClick={() => onBeslis(l.id, 'geweigerd')}>Nee, niet betalen</button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
